import { render, staticRenderFns } from "./LogoSection.vue?vue&type=template&id=3306dd88&scoped=true"
import script from "./LogoSection.vue?vue&type=script&lang=js"
export * from "./LogoSection.vue?vue&type=script&lang=js"
import style0 from "./LogoSection.vue?vue&type=style&index=0&id=3306dd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3306dd88",
  null
  
)

export default component.exports